import React from 'react'

const SuggestProductCardPrice = ({ product, className = "" }) => {
    return (
        < div className={`flex gap-1 ${className}`}>
            {
                product.price.formattedCampaignPrice ? (
                    <div className="text-md font-satoshi-bold m-0 text-primary-500">
                        {product.price.formattedCampaignPrice}{' '}
                    </div>
                ) : (
                    <div className="text-md font-satoshi-bold m-0">
                        {product.price.formattedPrice}{' '}
                    </div>
                )
            }
        </div >
    )
}

export default SuggestProductCardPrice